module.exports = __webpack_public_path__ + "static/media/qr_feed.db666bef.png";